// extracted by mini-css-extract-plugin
module.exports = {"NavMenu":"NavMenu_NavMenu__2AgZu"};